import { Select, type TypeSelectOption } from '@thefarmersfront/kitchen';

import { useShallow } from 'zustand/react/shallow';

import { useReceiveStore } from '~/store';

import { OPTION_PLT } from '~/constants';

import styles from './ReceiveRequestSelectCell.module.scss';

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > Select 셀 렌더러
 */
const ReceiveRequestSelectCell = ({ rowIndex, columnId: colId }: { rowIndex: number; columnId: 'palletYn' }) => {
  const [requestModalGoodsList, setRequestModalGoodsList] = useReceiveStore(
    useShallow((state) => [state.requestModalGoodsList, state.setRequestModalGoodsList])
  );

  if (requestModalGoodsList.length === 0) {
    return <div>-</div>;
  }

  const rowData = requestModalGoodsList[rowIndex];
  const cellData = rowData?.[colId] ?? null;
  const cellValue = OPTION_PLT.find(({ value }) => value === String(cellData)) || OPTION_PLT[0];

  const handleChange = (_: unknown, option: TypeSelectOption<string>) => {
    setRequestModalGoodsList([
      ...requestModalGoodsList.slice(0, rowIndex),
      {
        ...rowData,
        [colId]: JSON.parse(option.value),
      },
      ...requestModalGoodsList.slice(rowIndex + 1),
    ]);
  };

  return (
    <div className={styles['kitchen-component-cell']}>
      <Select
        size="tiny"
        dropdownPortalTarget={document.body}
        shouldCloseOnNotInView
        options={OPTION_PLT}
        value={cellValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default ReceiveRequestSelectCell;
